export const environment = {
    logo: 'https://s3.eu-west-1.amazonaws.com/assets.perse.io/perse_logos/perse_green_with_text.svg',
    production: true,
    environment: 'prod',
    // apiKey: 'PERSE-TEST-CLIENT-APIKEY-0fcac2975984',
    // testURL: 'http://localhost:4200/auth?key=UEVSU0UtVEVTVC1DTElFTlQtQVBJS0VZLTBmY2FjMjk3NTk4NA==',
    apiKey: '',
    whiteLabel: null,
    apiUrl: 'https://api.thelabrador.co.uk',
    header: 'Welcome to Perse',
    highlightHeader: '',
    primaryHeader: 'Insights',
    description: 'A comprehensive solution for all your energy data analytics and more.',

    msalConfig: {
        auth: {
          clientId: 'a0e202cc-950f-4a3d-858e-f6918d29b919',
          redirectUri: 'http://localhost:4200/',
          postLogoutRedirectUri: 'http://localhost:4200/',
          authority:
            'https://login.microsoftonline.com/851c9f9d-0cd7-47a3-bd35-8996e36285bd',
        },
        apiConfig: {
            scopes: ['https://analysis.windows.net/powerbi/api/.default'],
        },
        graphEndpoint: 'https://graph.microsoft.com/v1.0/me',
        nodeFabricHost: 'https://api.dev.perse.io/insight',
        getFabricDataEndpoint: '/v1/get-fabric-data',
        getFabricMetadataEndpoint: '/v1/get-fabric-metadata', //dropdown
        fetchFabricdataEndpoint: '/v1/fetch-fabric-data', //all tiles
        userPermissionsEndpoint: '/v1/user-permissions',
    },
}

